import gql from 'graphql-tag'

export const SYSTEM_NUMBERS_QUERY = gql`
  query getSystemnumbers($parentId: Float, $companyId: String) {
    getSystemnumbers(parentId: $parentId, companyId: $companyId) {
      id
      title
    }
  }
`
